
<h2 mat-dialog-title>
  {{ 'moderation_modal.title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-5">
  <p class="alert alert-warning">
    <i class="fal fa-exclamation-circle"></i>
    {{'moderation_modal.header'|translate}}
  </p>

  <form class="form-horizontal">
    <div class="form-group row mb-2">

      <label class="col-md-3 control-label text-md-end"
        for="why">{{'moderation_modal.why.label' | translate}}</label>

      <div class="col-md-8">
        <textarea class="form-control" id="why" name="why" [(ngModel)]="why"
          rows="5"
          placeholder="{{ 'moderation_modal.why.placeholder' | translate }}"></textarea>
      </div>

    </div>
    <div class="form-group row mb-2">

      <label class="col-md-3 control-label text-md-end">{{
        'moderation_modal.next.label' | translate }}</label>

      <div class="col-md-8">
        <p class="form-control-static">
          <span style="white-space: pre-line">{{
            'moderation_modal.next.description' | translate }}</span><br><br>
          <a
            href="https://help.teammood.com/en/articles/3950842-moderating-a-comment"
            target="_blank">
            <i class="far fa-info-square"></i> {{ 'moderation_modal.learn_more'
            | translate }}
          </a>
        </p>
      </div>

    </div>
  </form>

</mat-dialog-content>

<mat-dialog-actions class="justify-content-center">

  <button type="button"
    class="btn btn-default"
    mat-dialog-close>{{'cancel' | translate}}</button>

  <button type="submit"
    class="btn btn-warning"
    data-cy="moderation-dialog-submit"
    [disabled]="!why || why.length === 0"
    [mat-dialog-close]="why">{{'moderation_modal.cta' | translate}}</button>

</mat-dialog-actions>